import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {allEmployeesFetchState} from "../app/employee/selectors";
import {fetchEmployees} from "../app/employee/actions";

export const useFetchEmployees = () => {
    const dispatch = useDispatch()
    const fetchState = useSelector(allEmployeesFetchState)

    useEffect(() => {
        if (fetchState === 'idle') {
            dispatch(fetchEmployees() as any)
        }
    }, [fetchState, dispatch])
}

export default useFetchEmployees
